import React, { Component } from 'react';
import { Switch, Route, matchPath, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { SUBTABS, HISTORY_STEPS } from './ConstPaths';

import GatherInfoHistoryCurrentMethodEntry from './GatherInfoHistoryCurrentMethodEntry';
import GatherInfoHistoryCurrentMethodsReview from './GatherInfoHistoryCurrentMethodsReview';

const propTypes = {
  firstName: PropTypes.string,
  pronouns: PropTypes.arrayOf(PropTypes.string),
  currentMethods: PropTypes.arrayOf(PropTypes.object),
  onChangeCurrentMethods: PropTypes.func.isRequired,
  saveFormData: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired
};

const defaultProps = {
  firstName: 'the client',
  pronouns: ['they', 'them', 'their'],
  currentMethods: []
};

const steps = HISTORY_STEPS;
const BASE_URL = SUBTABS.HISTORY + "/";
const METHOD_STEPS = {
  ADD: 'add',
  EDIT: 'edit'
}
const pathForAdd = BASE_URL+ steps.CURRENT_METHODS + "/" + METHOD_STEPS.ADD;
const pathForEdit = BASE_URL+ steps.CURRENT_METHODS + "/" + METHOD_STEPS.EDIT;
class GatherInfoHistoryCurrentMethods extends Component {
  constructor(props){
    super(props);

    console.log("currentMethods: " + JSON.stringify(this.props.currentMethods));
    //manage the form values for each method as local state
    this.state = {
      methodName: "",
      methodNotes: "",
      methodNameError: "", //validation error message
      //the array of currentMethods is a bundle of the entered names and notes
      currentMethods: this.props.currentMethods
    };
    
    this.onDoneWithMethod = this.onDoneWithMethod.bind(this);
    this.onAddMethod = this.onAddMethod.bind(this); //essential for props.history to work in the function
    this.onEditMethod = this.onEditMethod.bind(this);
    this.onDeleteMethod = this.onDeleteMethod.bind(this);
  }
  
  //route to the child form to enter a new method
  onAddMethod(){
    this.setState({methodName:""});
    this.setState({methodNotes:""});
    this.setState({methodNameError: ""});
    const curURL = new URL(window.location.href);

    this.props.history.push({
      pathname: pathForAdd,
      search: curURL.search
    });
    //this.props.history.push(pathForAdd);
  }

  //same as Add, except pass in the selected methodName
  onEditMethod(index){
    var methodToEdit = this.state.currentMethods[index];
    this.setState({methodName: methodToEdit.name}); 
    this.setState({methodNotes: methodToEdit.notes}); 
    const curURL = new URL(window.location.href);

    this.props.history.push({
      pathname: pathForEdit + "/" + index,
      search: curURL.search
    });
    //this.props.history.push(pathForEdit + "/" + index);
  }

  //handle changes in the child form
  handleChange(field) {
    return evt => {
      this.setState({ [field]: evt.target.value });
    }
  }
  
  validate(methodName){
    let errorMsg = '';
    let allOK = true;
    if(methodName === ''){
      errorMsg = 'Please enter a name for the current method';
      allOK = false;
    }
    this.setState({methodNameError: errorMsg});
    return allOK;
  }

  //add the info from the child form into the currentMethods
  //then go to the review page
  onDoneWithMethod(){
    const history = this.props.history;
    let location = this.props.location;
    //https://stackoverflow.com/questions/45487779/how-to-get-params-in-parent-route-component
    const matchStep = matchPath(history.location.pathname, {
      path: "/gather-info/history/current-methods/:step",
    });
    const step = matchStep.params.step;
    const curURL = new URL(window.location.href);


    if(this.validate(this.state.methodName)){
      //replace if editing
      if(step === METHOD_STEPS.EDIT){
        const matchEdit = matchPath(this.props.history.location.pathname, {
          path: "/gather-info/history/current-methods/edit/:ix",
        });
        const ix = matchEdit.params.ix;
        const newCurrentMethods = this.state.currentMethods.slice(0);
        newCurrentMethods[ix].name = this.state.methodName;
        newCurrentMethods[ix].notes = this.state.methodNotes;
        this.setState({currentMethods: newCurrentMethods}, this.updateIt);
      }

      //concatenate if adding
      if(step === METHOD_STEPS.ADD){
        //add it to this.state.currentMethods, making sure to use setState
        //use an updater function to update currentMethods in the parent component properly
        //https://stackoverflow.com/questions/37435334/correct-way-to-push-into-state-array
        //https://stackoverflow.com/questions/38558200/react-setstate-not-updating-immediately
        const newCurrentMethod = {};
        newCurrentMethod.name = this.state.methodName;
        newCurrentMethod.notes = this.state.methodNotes;
        this.setState((prevState) => {
          return{
            currentMethods: prevState.currentMethods.concat(newCurrentMethod)
          };
        }, this.updateIt);
      }
      history.push({
        pathname: BASE_URL + steps.CURRENT_METHODS,
        search: curURL.search
      });
      //history.push(BASE_URL+ steps.CURRENT_METHODS);
    }
  }

  //https://stackoverflow.com/questions/43230622/reactjs-how-to-delete-item-from-list/43230714
  onDeleteMethod(ixToDelete){
    this.setState((prevState) => {
      return{
        currentMethods: prevState.currentMethods.filter(function(value, index, arr){
          return index !== ixToDelete;
        })
      };
    }, this.updateIt);
  }

  //Update the currentMethods in the parent component
  //Uses the callback supplied by parent
  updateIt = () => {
    this.props.onChangeCurrentMethods(this.state.currentMethods)
  }
    
  //If new props come in after rendering, update the views in this tab.
  //(This occurs when you refresh a view and it pulls data from the database.)
  componentDidUpdate(prevProps, prevState){
    //for values that are Arrays:
    if (_.isEqual(this.props.currentMethods, prevProps.currentMethods) === false){
      console.log("--incoming props: " + this.props.currentMethods + " differ from prev props: " + prevProps.currentMethods);
      this.setState({'currentMethods': this.props.currentMethods});
    };
  }

  render(){
    const firstName = this.props.firstName;
    const pronouns = this.props.pronouns;
    const saveFormData = this.props.saveFormData;
    const onContinue = this.props.onContinue;
     
    console.log("rendering GatherInfoHistoryCurrentMethods with currentMethods state: " + this.state.currentMethods);
    return(
      <>
      <Switch>
        <Route exact path={[pathForAdd, pathForEdit + "/:ix"]}>
          <GatherInfoHistoryCurrentMethodEntry
            firstName={firstName}
            pronouns={pronouns}
            methodName={this.state.methodName}
            onChangeMethodName={this.handleChange("methodName")}
            methodNameError={this.state.methodNameError}
            methodNotes={this.state.methodNotes}
            onChangeMethodNotes={this.handleChange("methodNotes")}
            onContinue={this.onDoneWithMethod}
          />
        </Route>
        <Route>
          <GatherInfoHistoryCurrentMethodsReview
            firstName={firstName} 
            pronouns={pronouns}
            currentMethods={this.state.currentMethods}
            onAddMethod={this.onAddMethod}
            onEditMethod={this.onEditMethod}
            onDeleteMethod={this.onDeleteMethod}
            saveCurrentMethods={saveFormData}
            onContinue={onContinue}
          />
        </Route>
      </Switch>
      </>
    );
  }
}

GatherInfoHistoryCurrentMethods.propTypes = propTypes;
GatherInfoHistoryCurrentMethods.defaultProps = defaultProps;

//withRouter needed to access history object in this section
export default withRouter(GatherInfoHistoryCurrentMethods);